module.exports = __webpack_public_path__ + "img/9.209374d7.png";